import { AppError, AppErrorEnum } from "./types";

export class BaseError extends Error {
  type: AppError;

  constructor(name: string, message?: string) {
    super(message ? `${name}: ${message}` : name);
    this.name = name;
    this.type = AppErrorEnum.BASE_ERROR;
  }
}

export class JsonError extends BaseError {
  constructor(message?: string) {
    super("JsonError", message);
    this.type = AppErrorEnum.JSON_ERROR;
  }
}

export class FetchError extends BaseError {
  constructor(message?: string) {
    super("FetchError", message);
    this.type = AppErrorEnum.FETCH_ERROR;
  }
}

export class NotFoundError extends BaseError {
  constructor(message?: string) {
    super("NotFoundError", message);
    this.type = AppErrorEnum.NOT_FOUND_ERROR;
  }
}

export class ValidationError extends BaseError {
  constructor(message?: string) {
    super("ValidationError", message);
    this.type = AppErrorEnum.VALIDATION_ERROR;
  }
}

export class InitError extends BaseError {
  constructor(message?: string) {
    super("InitError", message);
    this.type = AppErrorEnum.INIT_ERROR;
  }
}

export class MetaPixelError extends BaseError {
  constructor(message?: string) {
    super("MetaPixelError", message);
    this.type = AppErrorEnum.META_PIXEL_ERROR;
  }
}
